import { Segment } from '@mairistem/composants';

import ModesReglementListe from './ModesReglementListe/ModesReglementListe';

const ParametrageModesReglement = () => (
  <Segment style={{ height: '80%' }}>
    <ModesReglementListe />
  </Segment>
);

export default ParametrageModesReglement;
